import { useEffect, useRef, useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import phoneIcon from 'assets/images/login-call.svg'
import passIcon from 'assets/images/login-lock.svg'
import hidePassIcon from 'assets/images/login-hidepass.svg'
import { API_PATHS, PATHS } from 'config/routes'
import { useAtom } from 'jotai'
import { mobilePageTitleAtom } from 'config/store'
import { useLogin } from 'dataLayer/user'
import axios from 'axios'
import i18n from 'i18n'

function LoginPassMobile({ title }) {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const [isPass, setIsPass] = useState(true)
	function handlePass() {
		setIsPass(prev => !prev)
	}

	const errorRef = useRef(null)
	const { mutate, data, isLoading } = useLogin(
		() => {
			axios.get(API_PATHS.getUser).then(res => {
				const laguageUser = res?.data.data.language
				if (laguageUser) {
					i18n.changeLanguage(laguageUser)
				} else {
					i18n.changeLanguage('la')
				}
			})
			navigate(PATHS.HOME_PAGE)
		},
		() => {
			if (errorRef.current) {
				errorRef.current.innerText = data?.message
			}
		},
	)
	useEffect(() => {
		if (errorRef.current) {
			errorRef.current.innerText = ''
		}
	}, [])

	const [infoData, setInfoData] = useState({
		msisdn: '',
		password: '',
		grant_type: 'login',
	})
	function handleInfoChange(e) {
		const newInfoData = { ...infoData }
		newInfoData[e.target.id] = e.target.value
		setInfoData(newInfoData)
	}

	function handleLogin() {
		mutate(infoData)
	}

	return (
		<Container className="login-mobile" fluid>
			<Row>
				<h1>{t('modal.login.title')}</h1>
				<p>{t('modal.login.desc')}</p>
			</Row>
			<Row>
				<Form>
					<Form.Group className="mb-3 login-mobile-input">
						<img src={phoneIcon} alt="" />
						<Form.Control
							type="phone"
							placeholder={t('modal.form.phone')}
							onChange={handleInfoChange}
							id="msisdn"
						/>
					</Form.Group>
					<Form.Group className="mb-3 login-mobile-input">
						<img src={passIcon} alt="" />
						<Button
							variant="dark"
							onClick={handlePass}
							style={{
								position: 'absolute',
								top: '50%',
								right: 0,
								translate: '0 -50%',
								width: 26,
								height: 26,
								margin: 0,
								backgroundColor: 'transparent',
								border: 'none',
							}}
						>
							<img src={hidePassIcon} alt="" style={{ margin: 0 }} />
						</Button>
						<Form.Control
							type={isPass ? 'password' : 'text'}
							placeholder={t('modal.form.pass')}
							onChange={handleInfoChange}
							id="password"
						/>
					</Form.Group>
					<Row className="mb-3">
						<Col xs={6}>
							<Form.Group className="mb-3">
								<Form.Check
									type="checkbox"
									label={t('modal.login.save_pass')}
								/>
							</Form.Group>
						</Col>
						{parseInt(data?.responseCode) === 403 ? (
							<Col className="error-login text-end">
								<p ref={errorRef}>{data?.message}</p>
							</Col>
						) : null}
					</Row>
				</Form>
			</Row>
			<Button
				variant="primary"
				type="submit"
				disabled={isLoading}
				onClick={handleLogin}
			>
				{t('modal.login.login_pass_btn')}
				{isLoading ? (
					<Spinner animation="border" role="status"></Spinner>
				) : null}
			</Button>
			<Link to={PATHS.LOGIN_OTP_MOBILE}>
				<Button variant="dark">{t('modal.login.login_otp')}</Button>
			</Link>
		</Container>
	)
}

export default LoginPassMobile
